module.exports = __webpack_public_path__ + "static/media/GET_CODE_IMAGE.70eaa6cc.webp";